module.exports = __webpack_public_path__ + "static/img/1-1.b2d8b76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/1-1.jpg
// module id = uS9+
// module chunks = 0